/**
 * Shared guarded-recovery decision for the two reactive breakage signals
 * (MEIS-13220, design.md D6): a Vite dynamic-import preload failure and a
 * validation-class GraphQL error. Both event handlers call this with the
 * result of `canAutoReload()` (`reloadGuard.ts`) — if it allows, reload
 * immediately (self-heal); otherwise an automatic reload already failed to
 * clear the condition, so looping is prohibited and the prominent dialog is
 * shown instead.
 */
export type BreakageRecoveryAction = "reload" | "escalate";

export function decideBreakageRecovery(
  guardAllows: boolean
): BreakageRecoveryAction {
  return guardAllows ? "reload" : "escalate";
}
